import { render, staticRenderFns } from "./KPILoadUpload.vue?vue&type=template&id=4df68c11&scoped=true"
import script from "./KPILoadUpload.vue?vue&type=script&lang=js"
export * from "./KPILoadUpload.vue?vue&type=script&lang=js"
import style0 from "./KPILoadUpload.vue?vue&type=style&index=0&id=4df68c11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df68c11",
  null
  
)

export default component.exports